import { render, staticRenderFns } from "./PartCategoryListHandler.vue?vue&type=template&id=b0436d06"
import script from "./PartCategoryListHandler.vue?vue&type=script&lang=ts"
export * from "./PartCategoryListHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports